import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const Wrapper = styled.div`
  border-radius: 25px;
  display: flex;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.2);
  margin-bottom: 24px;
  color: black;
  align-items: center;
  gap: 8px;
  padding: 0 8px;
  width: 50%;
  position: relative;

  > div {
    width: 100%;
  }
`

export const ErrorText = styled.span`
  position: absolute;
  font-size: 12px;
  bottom: -18px;
  color: ${colors.red300};
`
